/**
 * DO NOT add i18
 * used solely in useMetric() & useGoalMetric()
 */
const tabs = ['ALL', 'LPA', 'CHOL', 'HDL', 'LDL', 'TRG'];

export { tabs };
